import { checkNullData } from 'utils';

export const findMinAndMax = (charts) => {
    if (checkNullData(charts[0]) || checkNullData(charts[1])) return {};

    const data = charts.map((chart) => chart.map((item) => item.data).flat()).flat();
    const min = Math.min(...data.map((item) => item.low || item.y));
    const max = Math.max(...data.map((item) => item.high || item.y));

    return { min, max };
};

export const newAdaptProjectionData = (data) => data
    .sort((a, b) => b.ProbabilityPercentage - a.ProbabilityPercentage)
    .map((group) => ({
        data: group.Values.map(({ date: d, value, AdditionalValue }) => ({ x: +new Date(d), low: AdditionalValue, high: value })),
    }));
